import React, { useState } from "react";
import Title from "./../Title";
import {
  BsBookmarkStarFill,
  BsCaretLeftFill,
  BsCaretRightFill,
  BsBookmarkPlus,
} from "react-icons/bs";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import { Movies } from "../../components/screen components/Data/MovieData";
import { Link } from "react-router-dom";
import Ratings from "../Ratings";
import useAuthContext from "../AuthContext/AuthContext";

const TopRatedMovies = ({ movie }) => {
  const { handleFilter } = useAuthContext();

  const handleCart = (id) => {
    handleFilter(id);
  };

  const [nextEl, setNextEl] = useState(null);
  const [prevEl, setPrevEl] = useState(null);

  const classNames =
    "hover:bg-dry transitions text-sm rounded w-8 h-8 flex-colo bg-subMain text-white";

  return (
    // Top rated movies section
    <div className="my-16 ">
      <Title title="Top Rated" Icon={BsBookmarkStarFill} />
      <div className="mt-10">
        <Swiper
          navigation={{ nextEl, prevEl }}
          autoplay={true}
          speed={1000}
          loop={true}
          modules={[Navigation, Autoplay]}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 10,
            },

            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1280: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          }}
        >
          {Movies.map((movie, index) => (
            <SwiperSlide key={index}>
              <div
                className="p-4 h-rate hovered border border-border bg-dry rounded-lg overflow-hidden "
                data-aos="zoom-in"
              >
                <img
                  src={movie.titleImage}
                  alt={movie.name}
                  className="w-full h-full object-cover rounded-lg"
                />
                <div className="px-4 hoveres gap-6 w-full text-center absolute bg-black bg-opacity-70 top-0 left-0 bottom-0">
                  <button
                    onClick={() => handleCart(movie.id)}
                    className="w-12 h-12 flex-colo transitions hover:bg-subMain rounded-full bg-white bg-opacity-30 text-white "
                  >
                    <BsBookmarkPlus />
                  </button>
                  <Link
                    className="font-semibold text-xl trancuted line-clamp-2"
                    to={`/movie/${movie.name}`}
                  >
                    {movie.name}
                  </Link>
                  <div className="flex gap-2 text-orange-500 ">
                    <Ratings value={movie.rate} />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="w-full px-1 flex-rows gap-6 pt-12">
          <button className={classNames} ref={(node) => setPrevEl(node)}>
            <BsCaretLeftFill />
          </button>

          <button className={classNames} ref={(node) => setNextEl(node)}>
            <BsCaretRightFill />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopRatedMovies;
